export interface IStorageConfig {
  useRam?: boolean
  useSession?: boolean
}

export interface IStorageBox {
  getItem(key: string): any
  setItem(key: string, value: any): void
  removeItem(key: string): void
  clear(): void
}

export class StorageBox implements IStorageBox {
  private storage: any = {}

  getItem(key: string): any {
    return this.storage.hasOwnProperty(key) ? this.storage[key] : null
  }

  setItem(key: string, value: any): void {
    this.storage[key] = value
  }

  removeItem(key: string): void {
    delete this.storage[key]
  }

  clear(): void {
    this.storage = {}
  }
}

export class Storage {
  private static _instance: Storage

  public static get instance(): Storage {
    if (!Storage._instance) {
      Storage._instance = new Storage({
        useRam: true,
      } as IStorageConfig)
    }
    return Storage._instance
  }

  constructor(config?: IStorageConfig) {
    if (config) {
      this.useRam = config.useRam || false
      this.useSession = config.useSession || false
    }
  }
  private useSession: boolean = false
  private useRam: boolean = false
  private storage: StorageBox = new StorageBox()

  private getSource(): IStorageBox {
    if (this.useSession && window.sessionStorage) {
      return window.sessionStorage as IStorageBox
    }

    if (!this.useRam && window.localStorage) {
      return window.localStorage as IStorageBox
    }

    return this.storage
  }

  getItem(key: string): any {
    let value = this.getSource().getItem(key)

    try {
      value = JSON.parse(value)
    } catch (e) {
      // do nothing
    }

    return value
  }

  setItem(key: string, value: any): void {
    let transformedValue = value

    try {
      transformedValue = JSON.stringify(value)
    } catch (e) {
      // do nothing
    }
    this.getSource().setItem(key, transformedValue)
  }

  removeItem(key: string): void {
    this.getSource().removeItem(key)
  }

  clear(): void {
    this.getSource().clear()
  }
}
